import React, {useEffect, useState} from "react";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import {NavLink} from "react-router-dom";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Modal from "../../common/Modals/Modal";
import noImg from "../../../asset/noImage.jpg";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';


const RenderRoomsCard = ({id, name, active, image, confirmDeleteRoom, objectId, baseUrl}) => {

    return (
        <Card className="card card-object card-room h-100">
            <Button className="btn card-delete" onClick={() => confirmDeleteRoom(id)}>
                <FontAwesomeIcon icon={"trash"}/>
            </Button>
            <CardMedia
                component="img"
                alt=""
                height="120"
                image={image.src ? `${baseUrl + image.src}` : noImg}

                title=""
            />
            <CardContent className="card-body p-2">
                <p className="card-title text-truncate">{name}</p>
                <p className="card-text">
                    {active === "Y"
                        ? <span className="badge active">активен</span>
                        : <span className="badge deactive">неактивен</span>}

                </p>
            </CardContent>
            <CardActionArea className="card-btn" component={NavLink} to={`/lk/${objectId}/rooms/${id}`}>
                <Box className="text-center">
                    Редактировать номер
                </Box>
            </CardActionArea>
            <CardActionArea className="card-btn" component={NavLink} to={`/lk/${objectId}/calendar/${id}`}>
                <Box className="text-center">
                    Редактировать цены
                </Box>
            </CardActionArea>

        </Card>
    )
}

//модалка удаления контакта
const RenderModalRoomDelete = ({toggleShow, show, deletedRoomName, deleteRoom}) => {

    return (
        <Modal toggleShow={toggleShow} show={show}
               title={"Удаление номера:"}
               textBtnOk={"Удалить"} btnOkAction={deleteRoom}>
            <div className="col-sm-12 mb-1">
                <p>Вы уверены, что хотите удалить номер: <b>{deletedRoomName}</b>?</p>
            </div>
        </Modal>
    )
}


const AdditionRoom = (props) => {
    const {roomsListFromBd, baseUrl} = props
    const objectId = props.match.params.objectId
    const roomId = props.match.params.roomId

    let [show, toggleModalShow] = useState(false);

    useEffect(() => {
        if (roomsListFromBd) {
            let filtredRoomsList = roomsListFromBd.filter(item => item.id !== roomId)
            setRoomsList([...filtredRoomsList])
        }
    }, [roomsListFromBd, roomId])



    const [roomsList, setRoomsList] = useState([])

    let [deletedRoom, setDeletedRoom] = useState();


    //открытие/закрытие модалок
    const toggleShow = () => {
        toggleModalShow(!show)
    };

    //подтверждение удаления номера
    const confirmDeleteRoom = (roomId) => {
        setDeletedRoom(roomsList.filter(item => item.id === roomId))
        toggleModalShow(!show)
    }

    //удаления номера
    const deleteRoom = () => {
        setRoomsList(roomsList.filter(item => item.id !== deletedRoom[0].id))
        toggleModalShow(!show)
    }


    return (
        <>
            {roomsList.length !== 0 && <div id="others-rooms" className="section d-none d-md-block pb-0">
                <div className="d-flex mb-2">
                    <h5 className="card-title mb-2">Другие номера</h5>

                    <Link component={NavLink} className="nav-link ms-auto" to={`/lk/${objectId}/rooms`}>Все номера
                        <FontAwesomeIcon icon={"chevron-right"} className="ms-1"/>
                        <FontAwesomeIcon icon={"chevron-right"} />
                        <FontAwesomeIcon icon={"chevron-right"} />
                    </Link>

                </div>

                <div className="row cards-object row-cols-md-3 row-cols-xl-4 row-cols-xxl-5 g-2">
                    {roomsList.slice(0, 5).map((room, index) => (
                        <div key={index} className="col">
                            <RenderRoomsCard {...room}
                                             objectId={objectId}
                                             confirmDeleteRoom={confirmDeleteRoom}
                                             baseUrl={baseUrl}/>
                        </div>
                    ))}

                </div>

                {show &&
                <RenderModalRoomDelete toggleShow={toggleShow}
                                       show={show}
                                       deletedRoomName={deletedRoom[0].name}
                                       deleteRoom={deleteRoom}
                                       />}
            </div>}

        </>
    )
}

export default AdditionRoom